import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { useCurrentOrganization } from '../contexts/OrganizationContext';

// Pushes the current org_id and project_id (when present) onto the Sentry
// scope as tags so events/traces are filterable per tenant. The deps are
// scalar IDs only — never the full context value — so this effect cannot
// participate in the OrganizationContext render-loop documented in
// organization_context_loop.md.
export function SentryTenantTagger() {
  const { currentOrgId } = useCurrentOrganization();
  const { projectId } = useParams<{ projectId: string }>();

  useEffect(() => {
    if (!import.meta.env.VITE_SENTRY_DSN) return;
    Sentry.setTag('organization_id', currentOrgId ?? null);
  }, [currentOrgId]);

  useEffect(() => {
    if (!import.meta.env.VITE_SENTRY_DSN) return;
    Sentry.setTag('project_id', projectId ?? null);
  }, [projectId]);

  return null;
}
